import * as LabelPrimitive from "@radix-ui/react-label";
import * as React from "react";
import { cn } from "../cn";

export const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(
      "mb-1 block font-medium text-ink-muted text-xs uppercase tracking-wider",
      className,
    )}
    {...props}
  />
));
Label.displayName = "Label";
